import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './fonts/delinda/DelindaScript-Regular.ttf'
import './fonts/delinda/DelindaScript-Regular.woff'
import './fonts/delinda/DelindaScript-Regular.woff2'
import './fonts/garamond/ArchiveGaramondPro-BoldItalic.ttf'
import './fonts/garamond/ArchiveGaramondPro-BoldItalic.woff'
import './fonts/garamond/ArchiveGaramondPro-BoldItalic.woff2'
import './fonts/garamond/ArchiveGaramondPro-Italic.ttf'
import './fonts/garamond/ArchiveGaramondPro-Italic.woff'
import './fonts/garamond/ArchiveGaramondPro-Italic.woff2'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
